import Screen from "../../components/Screen";
import { useNavigate, useSearchParams } from "react-router";
import { Wrapper } from "./SearchPage.styles";
import { routes } from "../../utils/routeHelper";
import { DeviceTabTypeEnum } from "../../types/DeviceTabTypeEnum";
import { useStore } from "../../store/store";
import { useEffect } from "react";
import CoreDeviceSearch from "@gf-core/widgets/widgets/CoreDeviceSearch";

export default function SearchPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const setActiveMenuId = useStore.useSetActiveMenuId();

  useEffect(() => {
    setActiveMenuId(undefined);
  }, []);

  const onNavigate = (
    accountId: string,
    installationId: string,
    deviceId?: string,
  ) => {
    if (deviceId) {
      navigate(
        routes.device.set(
          accountId,
          installationId,
          deviceId,
          DeviceTabTypeEnum.Overview,
        ),
      );
    } else {
      navigate(routes.installation.set(accountId, installationId));
    }
  };

  return (
    <Screen isAnimated>
      <Wrapper>
        <CoreDeviceSearch
          initialSearchParams={searchParams}
          onNavigate={onNavigate}
        />
      </Wrapper>
    </Screen>
  );
}
